class SplideCarousel extends HTMLElement {
  constructor() {
    super();
    
    this.splideSettings = {
      waitForTransition: true,
      wheel: false,
      drag: 'free',
      wheelMinThreshold: 1,
      mediaQuery: 'min',
      releaseWheel: true,
      omitEnd: true,
    }
  }
  
  connectedCallback() {
    var splide = new window.Splide(this, this.splideSettings);
    splide.mount();
  }
}

customElements.define('splide-carousel', SplideCarousel);

class SubCollections extends SplideCarousel {
  constructor() {
    super();
    
    this.splideSettings = {
      ...this.splideSettings,
      autoWidth: true,
      pagination: false,
      arrows: false,
      gap: 16,
      padding: 20,
      breakpoints: {
        700: {
          padding: 32,
          gap: 20,
          arrows: true,
        },
        1000: {
          padding: 48,
          gap: 30,
        },
      }
    }
  }
}

customElements.define('sub-collections', SubCollections);
